export const parseIfcFile = (fileContent) => {
  const elements = {};
  let currentElementId = 0;

  const lines = fileContent.split("\n");
  lines.forEach((line) => {
    const decodeLine = new TextDecoder("utf-8").decode(new Uint8Array(line.split("").map((char) => char.charCodeAt(0))));
    if (decodeLine.startsWith("#")) {
      const parts = decodeLine.split("=");
      if (parts.length > 1) {
        const entity = parts[1].trim().split("(")[0];
        const props = parts[1].trim().split("(")[1].split(",");
        if (entity.startsWith("IFC")) {
          if (props.length > 2) {
            const idString = props[2].trim().replace(/'/g, "").split(":").pop();
            if (!isNaN(idString) && idString.length === 7) {
              currentElementId = parseInt(idString, 10);
              const elementFamily = props[2].trim().replace(/'/g, "").split(":")[0];
              const elementType = props[2].trim().replace(/'/g, "").split(":")[1];
              elements[currentElementId] = { elementType: props[2].trim().replace(/'/g, "") };
            }
          }
          if (currentElementId > 0 && entity.startsWith("IFCPROPERTYSINGLEVALUE") && props.length > 2) {
            const propName = props[0].trim().replace(/'/g, "");
            const propValue = parts[1].trim().split("(")[2].split(")")[0].trim().replace(/'/g, "");
            if (propName === "Volume") {
              elements[currentElementId]["volume"] = parseFloat(propValue);
            } else if (propName === "Length") {
              elements[currentElementId]["length"] = parseFloat(propValue);
            } else if (propName === "TASK_id") {
              elements[currentElementId]["taskId"] = propValue;
            } else if (propName === "QTO_id") {
              elements[currentElementId]["qtoId"] = propValue;
            } else if (propName === "Mark") {
              elements[currentElementId]["elementName"] = propValue;
            } else if (propName === "Workset") {
              elements[currentElementId]["workset"] = propValue;
            }
          }
        }
      }
    }
  });

  return elements;
};

export const validateModel = (elements, qtoIds) => {
  const marks = [];
  const duplicateMarks = [];
  const noMark = [];
  const qtoIdNotExist = [];

  for (const elementId in elements) {
    const element = elements[elementId];
    const itemName = element.elementName || "";

    if (itemName === "") {
      noMark.push(elementId);
    } else if (marks.includes(itemName) && !duplicateMarks.includes(itemName)) {
      duplicateMarks.push(itemName);
    } else {
      marks.push(itemName);
    }
    if (!qtoIds.includes(element.qtoId) && !qtoIdNotExist.includes(element.qtoId)) {
      qtoIdNotExist.push(element.qtoId);
    }
  }

  duplicateMarks.sort();
  noMark.sort();
  qtoIdNotExist.sort();

  return {
    duplicateMarks: duplicateMarks,
    noMark: noMark,
    qtoIdNotExist: qtoIdNotExist,
  };
};
